<template>
    <div>
        <p>This is a <code>.deb</code> package built for Ubuntu/Mint Linux.
            Install it using your system package management tools, such as synaptic,
            Ubuntu software, apt, dpkg, etc. </p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for Linux</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/lin`">Download [{{ size }}]</a>
    </div>
      <h3>Install Java Runtime</h3>
        <p>Java Runtime is NOT included. You have to install it separately using your package manager.
            GanttProject requires Java Runtime version 11+, and this package will work with
          Java 11 Runtime from any major vendor, such as BellSoft Liberica, AdoptOpenJDK,
          Amazon Corretto, Azul Zulu, etc. If Java 11 Runtime is not found in your software sources,
          please refer to the instructions from vendors for adding their repositories to your system.</p>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered through our Update Channel. Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time. When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
    export default {
        name: "DownloadLin30",
        props: {
            releaseDate: String,
            size: String,
            version: String,
            virustotalHash: String
        }
    }
</script>

<style scoped>

</style>
